<div [className]="!((bluePrismList$ | async) && (bluePrismList$ | async).length) ? 'bmc-blue-prism__hidden' : 'bmc-blue-prism'">
  <bots-list class="bmc-blue-prism__left-side-component" [botsList]="(bluePrismList$ | async)"
    [isLoading]="(isLoading$ | async)" (selectedBotChanged)="onSelectedBotChanged($event)" #botsList></bots-list>
  <blue-prism-detail-wrapper
    [ngClass]="{'bmc-blue-prism__hidden': !((bluePrismList$ | async) && (bluePrismList$ | async).length) }" #bluePrismDetailWrapper>
  </blue-prism-detail-wrapper>
</div>
<bots-empty *ngIf="(!(bluePrismList$ | async) || !(bluePrismList$  | async).length) && !(isLoading$ | async)">
  {{'RPA_BOTS.EMPTY' | translate}}
</bots-empty>
